import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Crown, Lock, Heart, Wind, Calendar, Target, Home, FileText } from 'lucide-react';

export default function PremiumLock({ feature }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-6 animate-fade-in">
        <div className="w-20 h-20 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
          <Lock className="w-10 h-10 text-primary" />
        </div>
        
        <h2 className="font-heading text-2xl">
          Din provperiod har gått ut
        </h2>
        
        <p className="text-muted-foreground">
          Uppgradera till premium för att fortsätta använda {feature.toLowerCase()} och alla andra verktyg.
        </p>

        <div className="bg-card rounded-2xl p-6 text-left space-y-4">
          <p className="font-medium">Allt ingår i Premium:</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-center gap-2">
              <FileText className="w-4 h-4 text-primary" />
              Dagbok & Reflektioner
            </li>
            <li className="flex items-center gap-2">
              <Heart className="w-4 h-4 text-primary" />
              Känslor, Tacksamhet & Självkännedom
            </li>
            <li className="flex items-center gap-2">
              <Wind className="w-4 h-4 text-primary" />
              Andning, Meditation & Fokus
            </li>
            <li className="flex items-center gap-2">
              <Home className="w-4 h-4 text-primary" />
              Städschema, Inköpslistor & Rutiner
            </li>
            <li className="flex items-center gap-2">
              <Target className="w-4 h-4 text-primary" />
              Mål, Vanor & Anteckningar
            </li>
            <li className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-primary" />
              Hälsa, Ekonomi & Relationer
            </li>
          </ul>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/subscription')}
            className="w-full rounded-full py-6"
            data-testid="upgrade-premium-btn"
          >
            <Crown className="w-4 h-4 mr-2" />
            Uppgradera till Premium
          </Button>
          <Button 
            variant="ghost"
            onClick={() => navigate('/dashboard')}
            className="w-full rounded-full"
          >
            Tillbaka
          </Button>
        </div>
      </div>
    </div>
  );
}
